import { ArrowRight, Download, Loader2 } from "lucide-react";
import { Contract } from "../types";

export function DetailTitle({
  contract,
  onExport,
  exporting,
}: {
  contract: Contract;
  onExport: () => void;
  exporting?: boolean;
}) {
  return (
    <div className="flex flex-col gap-1.5 bg-white p-5 rounded-s-md rounded-e-md">
      <div className="flex items-start justify-between gap-3">
        <h1 className="text-[16px] font-bold text-[#525062] flex items-center gap-2">
          {contract.from}{" "}
          <span className="text-[#E2682B] mx-0.5 inline-flex items-center">
            <ArrowRight className="w-6 h-5 text-[#E2682B]" />{" "}
          </span>
          {contract.to}
        </h1>
        <div className="flex gap-2 pt-1">
          <HeaderBtn onClick={onExport} disabled={exporting}>
            {exporting ? (
              <Loader2 size={14} className="animate-spin" />
            ) : (
              <Download size={14} />
            )}{" "}
            {exporting ? "Exporting…" : "Export"}
          </HeaderBtn>
        </div>
      </div>

      <div className="text-xs text-[#6B6877] flex flex-wrap items-center gap-1">
        <span className="flex gap-2">
          LoA{" "}
          <strong className="text-[#4A5160] font-medium">{contract.loa}</strong>
        </span>
        <span className="text-[#828A99] mx-1">·</span>
        <span className="flex gap-2">
          Signed{" "}
          <strong className="text-[#4A5160] font-medium">
            {contract.signed}
          </strong>
        </span>
        <span className="text-[#828A99] mx-1">·</span>
        <span className="flex gap-2">
          Banking factor{" "}
          <strong className="text-[#4A5160] font-medium">{contract.bf}</strong>
        </span>
        <span className="text-[#828A99] mx-1">·</span>
        <span className="flex gap-2">
          Window{" "}
          <strong className="text-[#4A5160] font-medium">
            {contract.windowStart} – {contract.windowEnd}
          </strong>
        </span>
      </div>
    </div>
  );
}

function HeaderBtn({
  children,
  onClick,
  disabled,
}: {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="inline-flex items-center gap-1.5 border border-[#ECEEF3] bg-white rounded-lg px-3 py-1.5 text-xs text-[#525062] font-medium hover:border-[#DADCE3] hover:bg-[#FAFBFD] disabled:opacity-60 disabled:cursor-not-allowed"
    >
      {children}
    </button>
  );
}

export default DetailTitle;
